import { render, staticRenderFns } from "./DistrictsComponent.vue?vue&type=template&id=182b106f&scoped=true"
import script from "./DistrictsComponent.vue?vue&type=script&lang=js"
export * from "./DistrictsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182b106f",
  null
  
)

export default component.exports